/**
 * @generated SignedSource<<73ed2a939682dd6de2f585d5f8d8ada8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MemoryAttributionFeedbackType = "NOT_RELEVANT" | "RELEVANT" | "%future added value";
export type SubmitMemoryAttributionFeedbackInput = {
  conversationId?: any | null | undefined;
  feedbackType: MemoryAttributionFeedbackType;
  llmConversationId?: any | null | undefined;
  llmMessageId?: string | null | undefined;
  memoryId: string;
  messageId?: string | null | undefined;
};
export type useSubmitMemoryAttributionFeedbackMutationSubmitMemoryAttributionFeedbackMutation$variables = {
  input: SubmitMemoryAttributionFeedbackInput;
};
export type useSubmitMemoryAttributionFeedbackMutationSubmitMemoryAttributionFeedbackMutation$data = {
  readonly submitMemoryAttributionFeedback: {
    readonly success: boolean;
  };
};
export type useSubmitMemoryAttributionFeedbackMutationSubmitMemoryAttributionFeedbackMutation = {
  response: useSubmitMemoryAttributionFeedbackMutationSubmitMemoryAttributionFeedbackMutation$data;
  variables: useSubmitMemoryAttributionFeedbackMutationSubmitMemoryAttributionFeedbackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubmitMemoryAttributionFeedbackPayload",
    "kind": "LinkedField",
    "name": "submitMemoryAttributionFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSubmitMemoryAttributionFeedbackMutationSubmitMemoryAttributionFeedbackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSubmitMemoryAttributionFeedbackMutationSubmitMemoryAttributionFeedbackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7c8b152c1a11b0a1223ca09e5e7ec8c4",
    "id": null,
    "metadata": {},
    "name": "useSubmitMemoryAttributionFeedbackMutationSubmitMemoryAttributionFeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation useSubmitMemoryAttributionFeedbackMutationSubmitMemoryAttributionFeedbackMutation(\n  $input: SubmitMemoryAttributionFeedbackInput!\n) {\n  submitMemoryAttributionFeedback(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "fa39dbf0de26fb8bf46ed21d4a25447c";

export default node;
